// gloss
export const AUTH0_AUDIENCE = process.env.NEXT_PUBLIC_AUTH0_AUDIENCE || 'https://api.joinzealot.com';

// gloss
export const AUTH0_SCOPE = 'openid profile email api:request offline_access';

// gloss
export const AUTH0_CONNECTION_DB = 'Community-DB';

// gloss
export const AUTH0_CLAIMS_NAMESPACE = 'https://joinzealot.com/claims';

// gloss
export const AUTH0_CLAIMS_EMAIL_KEY = `${AUTH0_CLAIMS_NAMESPACE}/email`;

// gloss
let _cachedDomain: string | null = null;
let _cachedClientId: string | null = null;

// gloss
export const getAuth0Domain = () => {
  if (_cachedDomain) return _cachedDomain;
  const domain = process.env.NEXT_PUBLIC_AUTH0_DOMAIN;
  if (!domain) throw new Error('NEXT_PUBLIC_AUTH0_DOMAIN is not configured');
  _cachedDomain = domain.startsWith('http') ? domain : `https://${domain}`;
  return _cachedDomain;
};

// gloss
export const getAuth0ClientId = () => {
  if (_cachedClientId) return _cachedClientId;
  const clientId = process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID;
  if (!clientId) throw new Error('NEXT_PUBLIC_AUTH0_CLIENT_ID is not configured');
  _cachedClientId = clientId;
  return _cachedClientId;
};

// gloss
export const _resetEnvCache = () => {
  _cachedDomain = null;
  _cachedClientId = null;
};

// gloss
export const TOKEN_REFRESH_THRESHOLD_MS = 15 * 60 * 1000;

// gloss
export const TOKEN_EXPIRY_BUFFER_MS = 10_000;

// gloss
export const SILENT_AUTH_TIMEOUT_SECONDS = 5;

// gloss
export const MAX_MAGIC_TOKEN_AGE_MS = 30 * 24 * 60 * 60 * 1000;

// gloss
export const DEFAULT_POST_LOGIN_PATH = '/HomeDesktop';

// gloss
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  ID_TOKEN: 'id_token',
  LOGIN_METHOD: 'login_method',
  USER_ID: 'userID',
  USER_EMAIL: 'userEmail',
  USER_ID_SOURCE: 'userIDSource',
  USER_UUID: 'userUUID',
  BRAND: 'brand',
  AUTH_IN_PROGRESS: 'auth_in_progress',
  MAGIC_TOKEN: 'zealot_magic_token',
  MAGIC_TOKEN_EXPIRY: 'zealot_magic_token_expiry',
  EMBED_URL_SESSION: 'zealot_embed_url_session',
} as const;

// gloss
export const LOGIN_METHODS = {
  SERVICE: 'service',
  SMS: 'sms',
  EMAIL_OTP: 'email_otp',
  DB: 'db',
} as const;

export type LoginMethod = (typeof LOGIN_METHODS)[keyof typeof LOGIN_METHODS];

// gloss
export const MANUAL_REFRESH_METHODS: readonly LoginMethod[] = [
  LOGIN_METHODS.SMS,
  LOGIN_METHODS.EMAIL_OTP,
  LOGIN_METHODS.DB,
];

// gloss
export const EXPECTED_AUTH_ERRORS = [
  'login_required',
  'consent_required',
  'mfa_required',
  'Login required',
  'Consent required',
  'MFA required',
  'Unknown or invalid refresh token.',
] as const;

// gloss
export const UNRECOVERABLE_AUTH_ERRORS = ['Unknown or invalid refresh token.'] as const;

// gloss
export const AUTH_TOKEN_CHANGED_EVENT = 'zealot:auth_token_changed';

// gloss
export const GRANT_TYPES = {
  REFRESH_TOKEN: 'refresh_token',
  PASSWORD_REALM: 'http://auth0.com/oauth/grant-type/password-realm',
} as const;
